import * as routing from "@phn/services/routing-manager";
import { isDesktop } from "@phn/utility/helper";
import { h } from "@stencil/core";

const OldNavigationDrawer = ({
  isLoading,
  receivedContent,
  locale,
  usingKeyboard,
  breakpoint,
}: {
  isLoading: boolean;
  receivedContent: boolean;
  locale: string;
  usingKeyboard: boolean;
  breakpoint: number;
}): HTMLElement | null => {
  if (routing.isOpened() || routing.isOpening()) {
    return isDesktop(breakpoint) ? (
      <phn-double-drawer
        class="drawer"
        style={isLoading ? { display: "none" } : {}}
        locale={locale}
        receivedContent={receivedContent}
      />
    ) : (
      <phn-single-drawer
        class="drawer"
        style={isLoading ? { display: "none" } : {}}
        breakpoint={breakpoint}
        usingKeyboard={usingKeyboard}
        locale={locale}
        receivedContent={receivedContent}
      />
    );
  }

  return null;
};

export default OldNavigationDrawer;
